"use client"

import type { ReactNode } from "react"
import { createContext, use, useCallback, useMemo, useState } from "react"

type ChannelSyncContextType = {
  triggerSync: (unitCode: string, source: "sidebar" | "navigation" | "manual") => void
  lastSyncTrigger: {
    unitCode: string
    source: "sidebar" | "navigation" | "manual"
    timestamp: number
  } | null
}

const ChannelSyncContext = createContext<ChannelSyncContextType | undefined>(undefined)

export function ChannelSyncProvider({ children }: { children: ReactNode }) {
  const [lastSyncTrigger, setLastSyncTrigger] = useState<ChannelSyncContextType["lastSyncTrigger"]>(null)

  const triggerSync = useCallback((unitCode: string, source: "sidebar" | "navigation" | "manual") => {
    console.log(`🎯 Sync triggered from ${source} for unit: ${unitCode}`)
    setLastSyncTrigger({
      unitCode,
      source,
      timestamp: Date.now(),
    })
  }, [])

  const contextValue = useMemo(
    () => ({ triggerSync, lastSyncTrigger }),
    [triggerSync, lastSyncTrigger],
  )

  return (
    <ChannelSyncContext value={contextValue}>
      {children}
    </ChannelSyncContext>
  )
}

export function useChannelSyncContext() {
  const context = use(ChannelSyncContext)
  if (context === undefined) {
    throw new Error("useChannelSyncContext must be used within a ChannelSyncProvider")
  }
  return context
}
